export const REGION = process.env.REACT_APP_REGION;
export const USER_POOL_ID = process.env.REACT_APP_USER_POOL_ID;
export const USER_POOL_WEB_CLIENT_ID = process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID;

export const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;
export const API_CDN_URL = process.env.REACT_APP_CDN_URL;
export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
